module.exports = __webpack_public_path__ + "img/lobster.e5842304.svg";